import { ActivityOverviewPage } from "./overview";

export const Activity = (): JSX.Element => {
  return <ActivityOverviewPage />;
};
